import React, { ReactNode, useCallback } from 'react';
import { Upload, UploadFile } from 'antd';
import { Colors } from '@common/tokens';
import { UploadChangeParam } from 'antd/lib/upload/interface';
import { useDocumentPreviewModalDeprecated } from '@common/components/document-preview-modal';

/**
 * Renders a link that allows the user to either drag or click to attach a file.
 * It also allows the user to click on the file to preview it
 */
export const InlineFileUploaderInput = ({
  instruction,
  multiple,
  onChange,
  value,
}: {
  instruction: ReactNode;
  multiple?: boolean;

  // these names are magic for antd
  // https://4x.ant.design/components/form/#components-form-demo-customized-form-controls
  // beware of renaming them
  value?: UploadFile[];
  onChange?: (value: UploadFile[]) => void;
}) => {
  const { handleOpen } = useDocumentPreviewModalDeprecated();

  const triggerChange = useCallback(
    (change: UploadChangeParam) => {
      onChange?.(change.fileList);
    },
    [onChange]
  );

  return (
    <div className="wk-inline-file-uploader-input">
      <Upload
        name="files"
        beforeUpload={() => false}
        defaultFileList={value}
        multiple={multiple}
        onChange={triggerChange}
        onPreview={(file) => {
          if (file.originFileObj) {
            handleOpen({ kind: 'uploadFile', data: file });
          } else if (file.response?.downloadUrl) {
            handleOpen({ kind: 'uploadedFile', data: file.response });
          }
        }}
      >
        <span className="upload-link">
          <b>Attach a File</b>
        </span>{' '}
        {instruction}
      </Upload>
      <style jsx>
        {`
          .wk-inline-file-uploader-input {
            max-width: 100%;
          }
          .wk-inline-file-uploader-input :global(.ant-upload-list-item-name) {
            color: ${Colors.elm};
            cursor: pointer;
          }
          .wk-inline-file-uploader-input :global(.errors-container) {
            margin-top: 8px;
          }
          .wk-inline-file-uploader-input :global(.upload-link) {
            color: ${Colors.elm};
            cursor: pointer;
          }
        `}
      </style>
    </div>
  );
};
